import { AbstractContentState, useCmsContent } from '@cp-shared-19/frontend-integration';
import { PrivacyPolicy } from 'cpfr-common';
import { fetchPrivacyPolicy } from './PrivacyPolicySlice';
import { PrivacyPolicyContentSelector } from './PrivacyPolicyContentSelector';

export function usePrivacyPolicy(): AbstractContentState<PrivacyPolicy> {
    return useCmsContent(fetchPrivacyPolicy, PrivacyPolicyContentSelector);
}
